export default "__VITE_ASSET__BDhCoQmv__"